import React from 'react';
import { useUsers } from '../../core/utils/hooks/useUsers';
import EmbrapaSuinosScreen from '../../screen/EmbrapaSuinosScreen';

const EmbrapaSuinosContainer = () => {
  const { users } = useUsers();
  return <EmbrapaSuinosScreen users={users}/>
}

export default EmbrapaSuinosContainer;